<template>
    <div :style="{ paddingTop: height169 + 50 + 'px' }">
        <app-view :custom="true" @open="onOpen" @close="onClose">
            <div class="fixedTop">
                <div class="player" :style="item.thumb | bg">
                    <img src="static/169.png" />
                    <div v-if="item.push_status == 1 || item.push_status == 3">
                        <div class="video" id="video">
                            <video :poster="videoPoster" :src="videoUrl" x5-playsinline x-webkit-airplay webkit-playsinline playsinline controls controlslist="nodownload noremoteplayback noplaybackrate" :disablePictureInPicture="true"></video>
                        </div>
                    </div>
                    <div class="mask" v-else>
                        <div v-if="item.push_status == 0">
                            <div>直播将于{{ item.starttime | datetime }}开始</div>
                            <div v-if="leftTime >= 0">{{ leftTime | seconds }}</div>
                        </div>
                        <div v-else-if="item.push_status == 2">直播已结束</div>
                        <div v-else-if="item.push_status == 4">
                            直播已结束
                            <br />您可以
                            <a @click="onPlayerVideo(movid, urlid)">点击这里观看回放</a>
                        </div>
                    </div>
                </div>
                <div class="info">
                    <span>
                        <i class="icon icon-zongrenshu"></i>
                        <span>{{ onlineCount | unit }}</span>
                    </span>
                    <span>
                        <i class="icon icon-guankancishu"></i>
                        <span>{{ item.hits | unit }}</span>
                    </span>
                    <label></label>
                    <a :class="{ on: item.good }" @click="onVote(item)">
                        <i class="icon icon-a-lujing133"></i>
                        <span v-if="item.good">{{ item.agree | unit }}</span>
                        <span v-else>点赞</span>
                    </a>
                    <a v-if="item.donate_url" @click="onShowSupport">
                        <i class="icon icon-a-Iconawesome-donate"></i>参与
                    </a>
                    <a v-if="shareVisible" @click="onShowShare">
                        <i class="icon icon-share"></i>分享
                    </a>
                </div>
            </div>
            <div class="content">
                <div class="title">{{ item.title }}</div>
                <div class="html" v-if="item.item_status == 0">
                    <div v-html="item.content"></div>
                </div>
                <div class="list" ref="scroller" v-else>
                    <div class="item" :class="{ on: i == timeIndex }" v-for="(item, i) in item.item_json">
                        <span>{{ item.key }}</span>
                        <span class="line1">{{ item.value }}</span>
                        <i class="icon icon-play1" v-if="i == timeIndex"></i>
                    </div>
                </div>
            </div>
            <div class="ad" v-if="item.ad && adVisible">
                <a @click="onOpenUrl(item.ad.linkurl)">
                    <img :src="item.ad.image">
                </a>
                <a class="close" @click="onAdClosed">关闭</a>
            </div>
        </app-view>
    </div>
</template>
<script>
import app from '../../app'
import { createAliPlayer, dispostAliPlayer } from '../../util/aliplayer'
import { n2 } from '../../util/filters'
import AppView from '../components/AppView.vue'
export default {
    components: { AppView, },
    filters: {
        bg(url) {
            return {
                backgroundImage: 'url(' + url + ')'
            }
        }
    },
    computed: {
        shareVisible() {
            return window.inApp && this.item.share_status > 0
        },
        id() {
            return this.$route.params.id
        },
        height169() {
            return window.innerWidth * 9 / 16
        }
    },
    data() {
        return {
            item: {},
            onlineCount: 0,
            leftTime: -1,
            timeIndex: -1,
            player: null,
            chatWS: null,
            movid: '',
            urlid: '',
            videoUrl: '',
            videoPoster: '',
            adVisible: true,
        }
    },
    methods: {
        onAdClosed() {
            this.adVisible = false
        },
        onPlayerVideo(movid, urlid) {
            if (window.inApp) {
                app.fyPlayer(movid, urlid)
            } else {
                this.$router.push('/movie/' + movid + '?urlid=' + urlid)
            }
        },
        onShowShare() {
            let url = 'https://mfuyin.tv/index.html?#/lives/' + this.item.id
            if (this.item.share_url) {
                url = this.item.share_url
            }
            app.callShare(this.item.title, '一起看-福音影视网 iFUYIN.COM', this.item.thumb, url)
        },
        onShowSupport() {
            if (window.inApp) {
                app.openView(this.item.donate_url, this.item.donate_target == 1, true)
            } else {
                window.location.href = this.item.donate_url
            }
        },
        onOpenUrl(url) {
            if (window.inApp) {
                app.openView(url, true, true)
            } else {
                window.location.href = url
            }
        },
        async onOpen() {
            let item = await this.$service.lives.getDetail(this.id)
            this.$service.lives.postHit('live', this.id)
            if (item.item_json && item.item_json.length > 0) {
                let dt = new Date()
                let offset = dt.getTimezoneOffset() + 480
                item.item_json.forEach(item => {
                    let ts = item.key.split(':')
                    let value = parseInt(ts[0]) * 60 + parseInt(ts[1])
                    let dayMinute = 24 * 60
                    value = value - offset
                    if (value < 0) {
                        value = value + dayMinute
                    } else if (value > dayMinute) {
                        value = value - dayMinute
                    }

                    let hours = Math.floor(value / 60)
                    let minutes = value % 60
                    item.time = hours * 100 + minutes
                    item.key = n2(hours) + ':' + n2(minutes)
                })
            }

            let map = {}
            let goods = localStorage.getItem('live-goods')
            if (goods) {
                try {
                    map = JSON.parse(goods)
                } catch (e) {
                }
            }
            item.good = !!map[item.id]
            this.onlineCount = item.online
            this.item = item
            this.$service.common.title = this.item.title
            this.createChatWebsocket()
            this.updateLive(item)
        },
        onClose() {
            clearInterval(this.timer)
            if (this.player) {
                dispostAliPlayer('video', this.player)
            }
            clearInterval(this.chatTimer)
            if (this.chatWS) {
                this.chatWS.retry = false
                this.chatWS.close()
            }
        },
        onTimer() {
            if (this.leftTime > 0) {
                let offset = Math.floor(this.item.starttime - Date.now() / 1000)
                if (offset < 3600 * 24) {
                    this.leftTime = offset
                    if (offset <= 0) {
                        this.onOpen()
                        return
                    }
                } else {
                    this.leftTime = -1
                }
            }
            if (this.item.item_json && this.item.item_json.length > 0) {
                let dt = new Date()
                let hours = dt.getHours()
                let minutes = dt.getMinutes()
                let time = hours * 100 + minutes
                let i = this.item.item_json.findIndex(item => item.time > time)
                if (i < 0) {
                    i = this.item.item_json.length - 1
                } else {
                    i--
                }
                if (i >= 0 && this.timeIndex != i) {
                    this.timeIndex = i
                    window.scroll(0, i * 24)
                }
            }
        },
        async onVote(item) {
            if (item.good) {
                return
            }
            await this.$service.lives.postVote(item.id)
            item.good = true
            item.agree++
            let map = {}
            let goods = localStorage.getItem('live-goods')
            if (goods) {
                try {
                    map = JSON.parse(goods)
                } catch (e) {
                }
            }
            map[item.id] = 1
            localStorage.setItem('live-goods', JSON.stringify(map))
        },
        updateLive(item) {
            this.leftTime = -1
            if (item.push_status == 0) {
                let offset = Math.floor(item.starttime - Date.now() / 1000)
                if (offset < 3600 * 24) {
                    this.leftTime = offset
                }
            } else if (item.push_status == 1) {
                setTimeout(() => {
                    this.createPlayer(item.play_url, true)
                }, 20);
            } else if (item.push_status == 3) {
                if (item.player_type == 0) {
                    setTimeout(() => {
                        this.createPlayer(item.playback_url, false)
                    }, 20);
                } else {
                    item.push_status = 4
                    let ids = item.playback_urlid.split('-')
                    this.movid = ids[0]
                    this.urlid = ids[1]
                }
            }
            this.item = Object.assign({}, this.item, item)
            clearInterval(this.timer)
            this.timer = setInterval(this.onTimer, 1000);
        },
        createPlayer(source, isLive) {
            if (window.app == 'ios') {
                this.videoUrl = source
                this.videoPoster = this.item.thumb
            } else {
                dispostAliPlayer('video', this.player)
                this.player = createAliPlayer('video', source, function () {
                }, { isLive, auto: true, poster: '', rate: !isLive })
            }
        },
        createChatWebsocket() {
            if (this.chatWS) {
                this.chatWS.retry = false
                this.chatWS.close()
                clearInterval(this.chatTimer)
            }
            let chat = new WebSocket('wss://ws-live.sanmanuela.net/yqk')
            //@ts-ignore
            chat.retry = true
            this.chatTimer = setInterval(() => {
                chat.send('{"type":"pong"}')
            }, 50000)
            chat.onmessage = (e) => {
                console.info('<<<', e.data)
                try {
                    let msg = JSON.parse(e.data)
                    switch (msg.type) {
                        case 'ping':
                            break;
                        case 'online':
                            this.onlineCount = msg.online_count
                            break;
                        case 'not_publish':
                        case 'publish':
                        case 'publish_done':
                        case 'playback':
                            if (this.player) {
                                dispostAliPlayer('video', this.player)
                                this.player = null
                            }
                            setTimeout(() => {
                                this.updateLive(msg.room)
                            }, msg.delay * 1000 + 2000);
                            break;
                        default:
                            console.info('unknow', e.data)
                            break
                    }
                } catch (err) {
                    console.info('unknow', e.data)
                }
            }
            chat.onopen = () => {
                chat.send(JSON.stringify({ type: 'login', room_id: this.id }))
            }
            chat.onclose = () => {
                //@ts-ignore
                console.info('-chat close', chat.retry)
                //@ts-ignore
                if (chat.retry) {
                    setTimeout(this.createChatWebsocket, 3000)
                }
            }
            chat.onerror = () => {
                //@ts-ignore
                console.info('-chat error', chat.retry)
                chat.close()
                //@ts-ignore
                if (chat.retry) {
                    //@ts-ignore
                    chat.retry = false
                    setTimeout(this.createChatWebsocket, 3000)
                }
            }
            this.chatWS = chat
        }
    }
}
</script>
<style scoped lang="scss">
.ad {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;

    a {
        display: block;

        img {
            display: block;
            width: 100%;
        }
    }

    .close {
        position: absolute;
        right: 0;
        top: 0;
        background-color: black;
        color: white;
        font-size: 12px;
        padding: 0 2px;
    }
}

.fixedTop {
    z-index: 34;
    top: 88px !important;
}

.player {
    position: relative;
    background-color: black;
    background-size: cover;
    background-position: center center;

    .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: bold;
        text-align: center;

        a {
            color: orange;
        }
    }

    img {
        display: block;
        width: 100%;
    }

    .video {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        video {
            width: 100%;
            height: 100%;
        }
    }
}

.content {
    padding-top: 10px;

    .title {
        font-size: 16px;
        padding: 0 10px;
    }
}

.html {
    padding: 10px;
}

.info {
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 10px;
    background-color: white;
    font-size: 16px;

    label {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    >span {
        color: #666;

        &+span {
            margin-left: 20px;
        }
    }

    a {
        color: #666;

        &.on {
            color: #f05f5f;
        }

        &+a {
            margin-left: 20px;
        }
    }
}

.list {
    padding-top: 10px;
    margin-bottom: 50px;

    .item {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 12px 0 24px;
        font-size: 14px;
        height: 24px;

        span {
            &:first-child {
                width: 50px;
            }

            &:nth-child(2) {
                flex: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        i {
            position: absolute;
            left: 9px;
            font-size: 10px;
        }

        &.on {
            color: #f05f5f;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Room.vue?1ce6f358